export default [
  {
    path: '/subscription-benefits',
    name: 'subscription-benefits',
    component: () => import('./pages/subscription-benefits.vue'),
    meta: {
      resource: 'subscriptions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Subscription Benefits',
      breadcrumb: [
        {
          text: 'Subscription Benefits',
          active: true,
        },
      ],
    },
  },
  {
    path: '/subscription-plans',
    name: 'subscription-plans',
    component: () => import('./pages/subscription-plans-list.vue'),
    meta: {
      resource: 'subscriptions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Subscription Plans',
      breadcrumb: [
        {
          text: 'Subscription Plans',
          active: true,
        },
      ],
    },
  },
  {
    path: '/subscribed-users',
    name: 'subscribed-users',
    component: () => import('./pages/subscribed-users.vue'),
    meta: {
      resource: 'subscriptions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Subscribed Users',
      breadcrumb: [
        {
          text: 'Subscribed Users',
          active: true,
        },
      ],
    },
  },
  {
    path: '/subscription-plans/new',
    name: 'subscription-plans-new',
    component: () => import('./pages/new-subscription-plan.vue'),
    meta: {
      resource: 'subscriptions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Subscription Plan',
      breadcrumb: [
        {
          text: 'Subscription Plans',
          to: '/subscription-plans',
        },
      ],
    },
  },
]
